import { render, staticRenderFns } from "./voting-stage.vue?vue&type=template&id=23a62466&scoped=true&"
import script from "./voting-stage.vue?vue&type=script&lang=js&"
export * from "./voting-stage.vue?vue&type=script&lang=js&"
import style0 from "./voting-stage.vue?vue&type=style&index=0&id=23a62466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a62466",
  null
  
)

export default component.exports